const FormRadio = ({
  label = "Label",
  name = "",
  value = "",
  className = "",
  icon = null,
  onChange,
  checked = false,
  disabled = false,
}) => {
  const stringValue = String(value);
  const inputId = `radio-${stringValue}`;
  const Icon = icon;

  return (
    <div className={`form-check justify-content-between ${className}`}>
      <div className="d-flex align-items-center">
        <input
          className="form-check-input"
          type="radio"
          name={name}
          value={stringValue}
          id={inputId}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <label className="form-check-label" htmlFor={inputId}>
          {label}
        </label>
      </div>
      {Icon && <Icon className="me-2 form-check-icon" />}
    </div>
  );
};

export default FormRadio;
